import { shrpaApi } from "@/repos/axios";
import type { BundleSocialAccount } from "@contracts/socialIntegration";
import { getCalendarTestMode } from "@logic/calendarTestModeManager";

const getCalendarId = () => getCalendarTestMode();

export default class SocialIntegrationRepo {
  static async createPortalLink(customerId: string, returnUrl: string): Promise<string> {
    const calendarId = getCalendarId();
    const url = `/social-account/manage/${encodeURIComponent(customerId)}/${encodeURIComponent(calendarId)}/portal-link`;
    const { data } = await shrpaApi.post<string>(url, null, { params: { returnUrl } });
    return data;
  }

  static async getSocialAccounts(customerId: string): Promise<BundleSocialAccount[]> {
    const calendarId = getCalendarId();
    const url = `/social-account/manage/${encodeURIComponent(customerId)}/${encodeURIComponent(calendarId)}/social-accounts`;
    const { data } = await shrpaApi.get<BundleSocialAccount[]>(url);
    return data;
  }
}
